CustomTC.define('modules/language',['modules/util', 'modules/core', 'modules/config'], function(util, core, config) {
    return {
        loadingText: "Loading...",
        blueMsgBoxLine1: "This is an interactive video",
        blueMsgBoxLine2: "Tap or ",
        blueMsgBoxLine21: "Click to explore",
        mainPlayBtnTitle: "Play",
        playTooltip: "Play",
        pauseTooltip: "Pause",
        volumeMuteTooltip: "Mute",
        volumeUnmuteTooltip: "Unmute",
        recastTooltip: "reCast",
        recastRemoveTooltip: "Remove reCast",
        commentTooltip: "Comment",
        infoTooltip: "Info",
        shareTooltip: "Share",
        fullscreenTooltip: "Fullscreen",
        fullscreenExitTooltip: "Exit Fullscreen",
        embedConfirmationPopupBtnNo: "No",
        embedConfirmationPopupBtnYes: "Yes, please",
        recastPopupBoxTitle: "reCast This TouchCast",
        recastPopupBoxTitleRemove: "Remove reCast",
        recastPopupBoxDesc: "reCasting will post this <br> TouchCast to your channel",
        commentPopupTitle: "Comments",
        commentPopupBtnPost: "Post",
        commentPopupInputPlaceholder: "Add your own comment.",
        commentPopupNoCommentsText: "No Comments.",
        infoBoxBookmarkText: "Bookmark",
        infoBoxBookmarkTooltip: "Bookmark",
        infoBoxRemoveBookmarkTooltip: "Remove Bookmark",
        infoBoxFollowText: "Follow",
        infoBoxFollowTooltip: "Follow Channel",
        infoBoxUnfollowText: "Unfollow",
        infoBoxUnfollowTooltip: "Unfollow Channel",
        infoBoxVideoStatusViews: "Views",
        infoBoxVideoStatusShares: "Shares",
        infoBoxVideoStatusRecasts: "reCasts",
        infoBoxFlagText: "Flag",
        infoBoxFlagPopupTitle: "Report This TouchCast",
        infoBoxFlagPopupDesc: "After you report the TouchCast with your reason, our staff will review it. If the video is found to be in violation of our <a href=\"#\" title=\"Terms of Use\">Terms of Use<\/a>, it will be removed. Users who continually violate our Terms of Use will have their accounts penalized or possibly banned from TouchCast permanently.",
        infoBoxFlagInputPlacehoder: "Reason for flagging",
        infoBoxFlagBtnSubmitText: "Flag <span><!-- --><\/span>",
        infoBoxFlagBtnCancelText: "Cancel <span><!-- --><\/span>",
        infoBoxUserDescText: "This video has no description.",
        shareBoxShareTabText: "Share",
        shareBoxEmbedTabText: "Embed",
        shareBoxEmbedCopyText: "Copy",
        shareBoxShareIconFacebook: "Share on Facebook",
        shareBoxShareIconTwitter: "Share on Twitter",
        videoCommentPopupMsg: "Do you want to open TouchCast.com in a new tab so that you can login there and be able to post a comment?",
        videoReCastPopupMsg: "Do you want to open TouchCast.com in a new tab so that you can login there and be able to reCast this TouchCast?",
        videoFollowPopupMsg: "Do you want to open TouchCast.com in a new tab so that you can login there and be able to Follow this channel?",
        videoUnFollowPopupMsg: "Do you want to open TouchCast.com in a new tab so that you can login there and be able to UnFollow this channel?",
        videoBookmarkPopupMsg: "Do you want to open TouchCast.com in a new tab so that you can login there and be able to Bookmark this TouchCast?",
        videoRemoveBookmarkMsg: "Do you want to open TouchCast.com in a new tab so that you can login there and be able to Remove Bookmark this TouchCast?",
        tcInsideTcTopLeftReturnText: "Return to previous TouchCast",
        tcEndScreenShareThisTouchcast: "Share <br>This TouchCast",
        tcEndScreenDownloadTouchcast: "Download <br>TouchCast App",
        tcEndScreenReplayTouchcast: "Replay <br>TouchCast",
        settingsSubtitleLabel: "Subtitles/CC",
        settingsTooltip: "Settings",
        subtitleTooltip: "Subtitles/Closed Captions",
        settingsSubtitleListHeading: "Subtitles/CC",
        subtitleEnglishLabel: "English",
        subtitleSpanishLabel: "Spanish",
        subtitleChineseLabel: "Chinese",
        subtitleHungarianLabel: "Hungarian",
        subtitleFrenchLabel: "French",
        subtitleRussianLabel: "Russian",
        subtitlePortugeseLabel: "Portuguese",
        subtitleItalianLabel: "Italian",
        subtitleJapaneseLabel: "Japanese",
        subtitleBrazilianLabel: "Brazilian",
        subtitleGermanLabel: "German",
        subtitleTurkishLabel: "Turkish",

        //get loading text
        getLoadingText: function() {
            return this.loadingText;
        },
        //set loading text
        setLoadingText: function(langText) {
            this.loadingText = langText;
        },
        //get blue message box line1
        getBlueMsgBoxLine1: function() {
            return this.blueMsgBoxLine1;
        },
        //set blue message box line1
        setBlueMsgBoxLine1: function(langText) {
            this.blueMsgBoxLine1 = langText;
        },
        //get blue message box line2
        getBlueMsgBoxLine2: function() {
            return this.blueMsgBoxLine2;
        },
        //set blue message box line2
        setBlueMsgBoxLine2: function(langText) {
            this.blueMsgBoxLine2 = langText;
        },
        //get blue message box line21
        getBlueMsgBoxLine21: function() {
            return this.blueMsgBoxLine21;
        },
        //set blue message box line21
        setBlueMsgBoxLine21: function(langText) {
            this.blueMsgBoxLine21 = langText;
        },
        //get main play button title
        getMainPlayBtnTitle: function() {
            return this.mainPlayBtnTitle;
        },
        //set main play button title
        setMainPlayBtnTitle: function(langText) {
            this.mainPlayBtnTitle = langText;
        },
        //get play button tooltip
        getPlayTooltip: function() {
            return this.playTooltip;
        },
        //set play button tooltip
        setPlayTooltip: function(langText) {
            this.playTooltip = langText;
        },
        //get pause button tooltip
        getPauseTooltip: function() {
            return this.pauseTooltip;
        },
        //set pause button tooltip
        setPauseTooltip: function(langText) {
            this.pauseTooltip = langText;
        },
        //get volume mute button tooltip
        getVolumeMuteTooltip: function() {
            return this.volumeMuteTooltip;
        },
        //set volume mute button tooltip
        setVolumeMuteTooltip: function(langText) {
            this.volumeMuteTooltip = langText;
        },
        //get volume unmute button tooltip
        getVolumeUnmuteTooltip: function() {
            return this.volumeUnmuteTooltip;
        },
        //set volume unmute button tooltip
        setVolumeUnmuteTooltip: function(langText) {
            this.volumeUnmuteTooltip = langText;
        },
        //get recast button tooltip
        getRecastTooltip: function() {
            return this.recastTooltip;
        },
        //set recast button tooltip
        setRecastTooltip: function(langText) {
            this.recastTooltip = langText;
        },
        //get recast remove button tooltip
        getRecastRemoveTooltip: function() {
            return this.recastRemoveTooltip;
        },
        //set recast remove button tooltip
        setRecastRemoveTooltip: function(langText) {
            this.recastRemoveTooltip = langText;
        },
        //get comment button tooltip
        getCommentTooltip: function() {
            return this.commentTooltip;
        },
        //set comment button tooltip
        setCommentTooltip: function(langText) {
            this.commentTooltip = langText;
        },
        //get info button tooltip
        getInfoTooltip: function() {
            return this.infoTooltip;
        },
        //set info button tooltip
        setInfoTooltip: function(langText) {
            this.infoTooltip = langText;
        },
        //get share button tooltip
        getShareTooltip: function() {
            return this.shareTooltip;
        },
        //set share button tooltip
        setShareTooltip: function(langText) {
            this.shareTooltip = langText;
        },
        //get fullscreen button tooltip
        getFullscreenTooltip: function() {
            return this.fullscreenTooltip;
        },
        //set fullscreen button tooltip
        setFullscreenTooltip: function(langText) {
            this.fullscreenTooltip = langText;
        },
        //get fullscreen exit button tooltip
        getFullscreenExitTooltip: function() {
            return this.fullscreenExitTooltip;
        },
        //set fullscreen exit button tooltip
        setFullscreenExitTooltip: function(langText) {
            this.fullscreenExitTooltip = langText;
        },
        //get embeded confirmation popup No button
        getEmbedConfirmationPopupBtnNo: function() {
            return this.embedConfirmationPopupBtnNo;
        },
        //set embeded confirmation popup No button
        setEmbedConfirmationPopupBtnNo: function(langText) {
            this.embedConfirmationPopupBtnNo = langText;
        },
        //get embeded confirmation popup Yes button
        getEmbedConfirmationPopupBtnYes: function() {
            return this.embedConfirmationPopupBtnYes;
        },
        //set embeded confirmation popup Yes button
        setEmbedConfirmationPopupBtnYes: function(langText) {
            this.embedConfirmationPopupBtnYes = langText;
        },
        //get recast popup box title
        getRecastPopupBoxTitle: function() {
            return this.recastPopupBoxTitle;
        },
        //set recast popup box title
        setRecastPopupBoxTitle: function(langText) {
            this.recastPopupBoxTitle = langText;
        },
        //get recast popup box title remove 
        getRecastPopupBoxTitleRemove: function() {
            return this.recastPopupBoxTitleRemove;
        },
        //set recast popup box title remove 
        setRecastPopupBoxTitleRemove: function(langText) {
            this.recastPopupBoxTitleRemove = langText;
        },
        //get recast popup box description
        getRecastPopupBoxDesc: function() {
            return this.recastPopupBoxDesc;
        },
        //set recast popup box description
        setRecastPopupBoxDesc: function(langText) {
            this.recastPopupBoxDesc = langText;
        },
        //get comment popup title
        getCommentPopupTitle: function() {
            return this.commentPopupTitle;
        },
        //set comment popup title
        setCommentPopupTitle: function(langText) {
            this.commentPopupTitle = langText;
        },
        //get comment popup post button
        getCommentPopupBtnPost: function() {
            return this.commentPopupBtnPost;
        },
        //set comment popup post button
        setCommentPopupBtnPost: function(langText) {
            this.commentPopupBtnPost = langText;
        },
        //get comment popup input plceholder
        getCommentPopupInputPlaceholder: function() {
            return this.commentPopupInputPlaceholder;
        },
        //set comment popup input plceholder
        setCommentPopupInputPlaceholder: function(langText) {
            this.commentPopupInputPlaceholder = langText;
        },
        //get comment popup no comments text
        getCommentPopupNoCommentsText: function() {
            return this.commentPopupNoCommentsText;
        },
        //set comment popup no comments text
        setCommentPopupNoCommentsText: function(langText) {
            this.commentPopupNoCommentsText = langText;
        },
        //get info box bookmark text
        getInfoBoxBookmarkText: function() {
            return this.infoBoxBookmarkText;
        },
        //set info box bookmark text
        setInfoBoxBookmarkText: function(langText) {
            this.infoBoxBookmarkText = langText;
        },
        //get info box bookmark tooltip
        getInfoBoxBookmarkTooltip: function() {
            return this.infoBoxBookmarkTooltip;
        },
        //set info box bookmark tooltip
        setInfoBoxBookmarkTooltip: function(langText) {
            this.infoBoxBookmarkTooltip = langText;
        },
        //get info box remove bookmark tooltip
        getInfoBoxRemoveBookmarkTooltip: function() {
            return this.infoBoxRemoveBookmarkTooltip;
        },
        //set info box remove bookmark tooltip
        setInfoBoxRemoveBookmarkTooltip: function(langText) {
            this.infoBoxRemoveBookmarkTooltip = langText;
        },
        //get info box follow text
        getInfoBoxFollowText: function() {
            return this.infoBoxFollowText;
        },
        //set info box follow text
        setInfoBoxFollowText: function(langText) {
            this.infoBoxFollowText = langText;
        },
        //get info box follow tooltip
        getInfoBoxFollowTooltip: function() {
            return this.infoBoxFollowTooltip;
        },
        //set info box follow tooltip
        setInfoBoxFollowTooltip: function(langText) {
            this.infoBoxFollowTooltip = langText;
        },
        //get info box unfollow text
        getInfoBoxUnfollowText: function() {
            return this.infoBoxUnfollowText;
        },
        //set info box unfollow text
        setInfoBoxUnfollowText: function(langText) {
            this.infoBoxUnfollowText = langText;
        },
        //get info box unfollow tooltip
        getInfoBoxUnfollowTooltip: function() {
            return this.infoBoxUnfollowTooltip;
        },
        //set info box unfollow tooltip
        setInfoBoxUnfollowTooltip: function(langText) {
            this.infoBoxUnfollowTooltip = langText;
        },
        //get info box video stats : views
        getInfoBoxVideoStatusViews: function() {
            return this.infoBoxVideoStatusViews;
        },
        //set info box video stats : views
        setInfoBoxVideoStatusViews: function(langText) {
            this.infoBoxVideoStatusViews = langText;
        },
        //get info box video status : shares
        getInfoBoxVideoStatusShares: function() {
            return this.infoBoxVideoStatusShares;
        },
        //set info box video status : shares
        setInfoBoxVideoStatusShares: function(langText) {
            this.infoBoxVideoStatusShares = langText;
        },
        //get info box video status : recasts
        getInfoBoxVideoStatusRecasts: function() {
            return this.infoBoxVideoStatusRecasts;
        },
        //set info box video status : recasts
        setInfoBoxVideoStatusRecasts: function(langText) {
            this.infoBoxVideoStatusRecasts = langText;
        },
        //get main play button title
        getInfoBoxFlagText: function() {
            return this.infoBoxFlagText;
        },
        //set main play button title
        setInfoBoxFlagText: function(langText) {
            this.infoBoxFlagText = langText;
        },
        //get info box flag popup title
        getInfoBoxFlagPopupTitle: function() {
            return this.infoBoxFlagPopupTitle;
        },
        //set info box flag popup title
        setInfoBoxFlagPopupTitle: function(langText) {
            this.infoBoxFlagPopupTitle = langText;
        },
        //get info box flag popup description
        getInfoBoxFlagPopupDesc: function() {
            return this.infoBoxFlagPopupDesc;
        },
        //set info box flag popup description
        setInfoBoxFlagPopupDesc: function(langText) {
            this.infoBoxFlagPopupDesc = langText;
        },
        //get info box flag input placeholder
        getInfoBoxFlagInputPlacehoder: function() {
            return this.infoBoxFlagInputPlacehoder;
        },
        //set info box flag input placeholder
        setInfoBoxFlagInputPlacehoder: function(langText) {
            this.infoBoxFlagInputPlacehoder = langText;
        },
        //get info box flag button submit text
        getInfoBoxFlagBtnSubmitText: function() {
            return this.infoBoxFlagBtnSubmitText;
        },
        //set info box flag button submit text
        setInfoBoxFlagBtnSubmitText: function(langText) {
            this.infoBoxFlagBtnSubmitText = langText;
        },
        //get info box flag button cancel text
        getinfoBoxFlagBtnCancelText: function() {
            return this.infoBoxFlagBtnCancelText;
        },
        //set info box flag button cancel text
        setinfoBoxFlagBtnCancelText: function(langText) {
            this.infoBoxFlagBtnCancelText = langText;
        },
        //get infobox usre description text
        getInfoBoxUserDescText: function() {
            return this.infoBoxUserDescText;
        },
        //set infobox usre description text
        setInfoBoxUserDescText: function(langText) {
            this.infoBoxUserDescText = langText;
        },
        //get Share box share tab text
        getShareBoxShareTabText: function() {
            return this.shareBoxShareTabText;
        },
        //set Share box share tab text
        setShareBoxShareTabText: function(langText) {
            this.shareBoxShareTabText = langText;
        },
        //get share box embed tab text
        getShareBoxEmbedTabText: function() {
            return this.shareBoxEmbedTabText;
        },
        //set share box embed tab text
        setShareBoxEmbedTabText: function(langText) {
            this.shareBoxEmbedTabText = langText;
        },
        //get Share box embed copy text
        getShareBoxEmbedCopyText: function() {
            return this.shareBoxEmbedCopyText;
        },
        //set Share box embed copy text
        setShareBoxEmbedCopyText: function(langText) {
            this.shareBoxEmbedCopyText = langText;
        },
        //get Share box share icon facebook
        getShareBoxShareIconFacebook: function() {
            return this.shareBoxShareIconFacebook;
        },
        //set Share box share icon facebook
        setShareBoxShareIconFacebook: function(langText) {
            this.shareBoxShareIconFacebook = langText;
        },
        //get Share box share icon twitter
        getShareBoxShareIconTwitter: function() {
            return this.shareBoxShareIconTwitter;
        },
        //set Share box share icon twitter
        setShareBoxShareIconTwitter: function(langText) {
            this.shareBoxShareIconTwitter = langText;
        },
        //get video comment popup message
        getVideoCommentPopupMsg: function() {
            return this.videoCommentPopupMsg;
        },
        //set video comment popup message
        setVideoCommentPopupMsg: function(langText) {
            this.videoCommentPopupMsg = langText;
        },
        //get video recast popup message
        getVideoReCastPopupMsg: function() {
            return this.videoReCastPopupMsg;
        },
        //set video recast popup message
        setVideoReCastPopupMsg: function(langText) {
            this.videoReCastPopupMsg = langText;
        },
        //get video follow popup message
        getVideoFollowPopupMsg: function() {
            return this.videoFollowPopupMsg;
        },
        //set video follow popup message
        setVideoFollowPopupMsg: function(langText) {
            this.videoFollowPopupMsg = langText;
        },
        //get video unfollow popup message
        getVideoUnFollowPopupMsg: function() {
            return this.videoUnFollowPopupMsg;
        },
        //set video unfollow popup message
        setVideoUnFollowPopupMsg: function(langText) {
            this.videoUnFollowPopupMsg = langText;
        },
        //get video bookmark popup message
        getVideoBookmarkPopupMsg: function() {
            return this.videoBookmarkPopupMsg;
        },
        //set video bookmark popup message
        setVideoBookmarkPopupMsg: function(langText) {
            this.videoBookmarkPopupMsg = langText;
        },
        //get video remove bookmark message
        getVideoRemoveBookmarkMsg: function() {
            return this.videoRemoveBookmarkMsg;
        },
        //set video remove bookmark message
        setVideoRemoveBookmarkMsg: function(langText) {
            this.videoRemoveBookmarkMsg = langText;
        },
        //get tc inside tc topleft return text
        getTcInsideTcTopLeftReturnText: function() {
            return this.tcInsideTcTopLeftReturnText;
        },
        //set tc inside tc topleft text
        setTcInsideTcTopLeftReturnText: function(langText) {
            this.tcInsideTcTopLeftReturnText = langText;
        },
        //get tc end screen share this touchcast 
        getTcEndScreenShareThisTouchcast: function() {
            return this.tcEndScreenShareThisTouchcast;
        },
        //set tc end screen share this touchcast 
        setTcEndScreenShareThisTouchcast: function(langText) {
            this.tcEndScreenShareThisTouchcast = langText;
        },
        //get tc end screen download touchcast
        getTcEndScreenDownloadTouchcast: function() {
            return this.tcEndScreenDownloadTouchcast;
        },
        //set tc end screen download touchcast
        setTcEndScreenDownloadTouchcast: function(langText) {
            this.tcEndScreenDownloadTouchcast = langText;
        },
        //get tc end screen replay touchcast 
        getTcEndScreenReplayTouchcast: function() {
            return this.tcEndScreenReplayTouchcast;
        },
        //set tc end screen replay touchcast 
        setTcEndScreenReplayTouchcast: function(langText) {
            this.tcEndScreenReplayTouchcast = langText;
        },
        //set settings popup message
        setSettingsTooltip: function(langText) {
            this.settingsTooltip = langText;
        },
        //get settings popup message
        getSettingsTooltip: function() {
            return this.settingsTooltip;
        },
        //set setting subtitle label
        setSettingsSubtitleLabel: function(langText) {
            this.settingsSubtitleLabel = langText;
        },
        //get setting subtitle label
        getSettingsSubtitleLabel: function() {
            return this.settingsSubtitleLabel;
        },
        //set setting subtitle list heading
        setSettingsSubtitleListHeading: function(langText) {
            this.settingsSubtitleListHeading = langText;
        },
        //get setting subtitle list heading
        getSettingsSubtitleListHeading: function() {
            return this.settingsSubtitleListHeading;
        },
        //set subtitle pop message
        setSubtitleTooltip: function(langText) {
            this.subtitleTooltip = langText;
        },
        //get subtitle pop message
        getSubtitleTooltip: function() {
            return this.subtitleTooltip;
        },
        // set subtitles lable
        setSubtitleLabel: function(langText, type) {
            if (type === 'en') {
                this.subtitleEnglishLabel = langText;
            } else if (type === 'es') {
                this.subtitleSpanishLabel = langText;
            } else if (type === 'hu') {
                this.subtitleHungarianLabel = langText;
            } else if (type === 'fr') {
                this.subtitleFrenchLabel = langText;
            } else if (type === 'it') {
                this.subtitleItalianLabel = langText;
            } else if (type === 'zh') {
                this.subtitleChineseLabel = langText;
            } else if (type === 'pt') {
                this.subtitlePortugeseLabel = langText;
            } else if (type === 'ja') {
                this.subtitleJapaneseLabel = langText;
            } else if (type === 'ru') {
                this.subtitleRussianLabel = langText;
            } else if (type === 'br') {
                this.subtitleBrazilianLabel = langText;
            } else if (type === 'de') {
                this.subtitleGermanLabel = langText;
            } else if (type === 'tr') {
                this.subtitleTurkishLabel = langText;
            }
        },
        // set subtitles lable
        getSubtitleLabel: function(type) {
            if (type === 'en') {
                return this.subtitleEnglishLabel;
            } else if (type === 'es') {
                return this.subtitleSpanishLabel;
            } else if (type === 'hu') {
                return this.subtitleHungarianLabel;
            } else if (type === 'fr') {
                return this.subtitleFrenchLabel;
            } else if (type === 'it') {
                return this.subtitleItalianLabel;
            } else if (type === 'zh') {
                return this.subtitleChineseLabel;
            } else if (type === 'pt') {
                return this.subtitlePortugeseLabel;
            } else if (type === 'ja') {
                return this.subtitleJapaneseLabel;
            } else if (type === 'ru') {
                return this.subtitleRussianLabel;
            } else if (type === 'br') {
                return this.subtitleBrazilianLabel;
            } else if (type === 'de') {
                return this.subtitleGermanLabel;
            } else if (type === 'tr') {
                return this.subtitleTurkishLabel;
            } else {
                return type;
            }
        },
        //set language texts
        setLanguage: function(language) {
            if (typeof(language.tc_loading_text) !== 'undefined') {
                this.setLoadingText(language.tc_loading_text);
            }
            if (typeof(language.blue_msg_box_line1) !== 'undefined') {
                this.setBlueMsgBoxLine1(language.blue_msg_box_line1);
            }
            if (typeof(language.blue_msg_box_line2) !== 'undefined') {
                this.setBlueMsgBoxLine2(language.blue_msg_box_line2);
            }
            if (typeof(language.blue_msg_box_line21) !== 'undefined') {
                this.setBlueMsgBoxLine21(language.blue_msg_box_line21);
            }
            if (typeof(language.main_play_btn_title) !== 'undefined') {
                this.setMainPlayBtnTitle(language.main_play_btn_title);
            }
            if (typeof(language.play_tooltip) !== 'undefined') {
                this.setPlayTooltip(language.play_tooltip);
            }
            if (typeof(language.pause_tooltip) !== 'undefined') {
                this.setPauseTooltip(language.pause_tooltip);
            }
            if (typeof(language.volume_mute_tooltip) !== 'undefined') {
                this.setVolumeMuteTooltip(language.volume_mute_tooltip);
            }
            if (typeof(language.volume_unmute_tooltip) !== 'undefined') {
                this.setVolumeUnmuteTooltip(language.volume_unmute_tooltip);
            }
            if (typeof(language.recast_tooltip) !== 'undefined') {
                this.setRecastTooltip(language.recast_tooltip);
            }
            if (typeof(language.recast_remove_tooltip) !== 'undefined') {
                this.setRecastRemoveTooltip(language.recast_remove_tooltip);
            }
            if (typeof(language.comment_tooltip) !== 'undefined') {
                this.setCommentTooltip(language.comment_tooltip);
            }
            if (typeof(language.info_tooltip) !== 'undefined') {
                this.setInfoTooltip(language.info_tooltip);
            }
            if (typeof(language.share_tooltip) !== 'undefined') {
                this.setShareTooltip(language.share_tooltip);
            }
            if (typeof(language.fullscreen_tooltip) !== 'undefined') {
                this.setFullscreenTooltip(language.fullscreen_tooltip);
            }
            if (typeof(language.fullscreen_exit_tooltip) !== 'undefined') {
                this.setFullscreenExitTooltip(language.fullscreen_exit_tooltip);
            }
            if (typeof(language.embed_confirmation_popup_btn_no) !== 'undefined') {
                this.setEmbedConfirmationPopupBtnNo(language.embed_confirmation_popup_btn_no);
            }
            if (typeof(language.embed_confirmation_popup_btn_yes) !== 'undefined') {
                this.setEmbedConfirmationPopupBtnYes(language.embed_confirmation_popup_btn_yes);
            }
            if (typeof(language.recast_popup_box_title) !== 'undefined') {
                this.setRecastPopupBoxTitle(language.recast_popup_box_title);
            }
            if (typeof(language.recast_popup_box_title_remove) !== 'undefined') {
                this.setRecastPopupBoxTitleRemove(language.recast_popup_box_title_remove);
            }
            if (typeof(language.recast_popup_box_desc) !== 'undefined') {
                this.setRecastPopupBoxDesc(language.recast_popup_box_desc);
            }
            if (typeof(language.comment_popup_title) !== 'undefined') {
                this.setCommentPopupTitle(language.comment_popup_title);
            }
            if (typeof(language.comment_popup_btn_post) !== 'undefined') {
                this.setCommentPopupBtnPost(language.comment_popup_btn_post);
            }
            if (typeof(language.comment_popup_input_placeholder) !== 'undefined') {
                this.setCommentPopupInputPlaceholder(language.comment_popup_input_placeholder);
            }
            if (typeof(language.comment_popup_no_comments_text) !== 'undefined') {
                this.setCommentPopupNoCommentsText(language.comment_popup_no_comments_text);
            }
            if (typeof(language.info_box_bookmark_text) !== 'undefined') {
                this.setInfoBoxBookmarkText(language.info_box_bookmark_text);
            }
            if (typeof(language.info_box_bookmark_tooltip) !== 'undefined') {
                this.setInfoBoxBookmarkTooltip(language.info_box_bookmark_tooltip);
            }
            if (typeof(language.info_box_remove_bookmark_tooltip) !== 'undefined') {
                this.setInfoBoxRemoveBookmarkTooltip(language.info_box_remove_bookmark_tooltip);
            }
            if (typeof(language.info_box_follow_text) !== 'undefined') {
                this.setInfoBoxFollowText(language.info_box_follow_text);
            }
            if (typeof(language.info_box_follow_tooltip) !== 'undefined') {
                this.setInfoBoxFollowTooltip(language.info_box_follow_tooltip);
            }
            if (typeof(language.info_box_unfollow_text) !== 'undefined') {
                this.setInfoBoxUnfollowText(language.info_box_unfollow_text);
            }
            if (typeof(language.info_box_unfollow_tooltip) !== 'undefined') {
                this.setInfoBoxUnfollowTooltip(language.info_box_unfollow_tooltip);
            }
            if (typeof(language.info_box_video_status_views) !== 'undefined') {
                this.setInfoBoxVideoStatusViews(language.info_box_video_status_views);
            }
            if (typeof(language.info_box_video_status_shares) !== 'undefined') {
                this.setInfoBoxVideoStatusShares(language.info_box_video_status_shares);
            }
            if (typeof(language.info_box_video_status_recasts) !== 'undefined') {
                this.setInfoBoxVideoStatusRecasts(language.info_box_video_status_recasts);
            }
            if (typeof(language.info_box_flag_text) !== 'undefined') {
                this.setInfoBoxFlagText(language.info_box_flag_text);
            }
            if (typeof(language.info_box_flag_popup_title) !== 'undefined') {
                this.setInfoBoxFlagPopupTitle(language.info_box_flag_popup_title);
            }
            if (typeof(language.info_box_flag_popup_desc) !== 'undefined') {
                this.setInfoBoxFlagPopupDesc(language.info_box_flag_popup_desc);
            }
            if (typeof(language.info_box_flag_input_placehoder) !== 'undefined') {
                this.setInfoBoxFlagInputPlacehoder(language.info_box_flag_input_placehoder);
            }
            if (typeof(language.info_box_flag_btn_submit_text) !== 'undefined') {
                this.setInfoBoxFlagBtnSubmitText(language.info_box_flag_btn_submit_text);
            }
            if (typeof(language.info_box_flag_btn_cancel_text) !== 'undefined') {
                this.setinfoBoxFlagBtnCancelText(language.info_box_flag_btn_cancel_text);
            }
            if (typeof(language.info_box_user_desc_text) !== 'undefined') {
                this.setInfoBoxUserDescText(language.info_box_user_desc_text);
            }
            if (typeof(language.share_box_share_tab_text) !== 'undefined') {
                this.setShareBoxShareTabText(language.share_box_share_tab_text);
            }
            if (typeof(language.share_box_embed_tab_text) !== 'undefined') {
                this.setShareBoxEmbedTabText(language.share_box_embed_tab_text);
            }
            if (typeof(language.share_box_embed_copy_text) !== 'undefined') {
                this.setShareBoxEmbedCopyText(language.share_box_embed_copy_text);
            }
            if (typeof(language.share_box_share_icon_facebook) !== 'undefined') {
                this.setShareBoxShareIconFacebook(language.share_box_share_icon_facebook);
            }
            if (typeof(language.share_box_share_icon_twitter) !== 'undefined') {
                this.setShareBoxShareIconTwitter(language.share_box_share_icon_twitter);
            }
            if (typeof(language.video_comment_popup_msg) !== 'undefined') {
                this.setVideoCommentPopupMsg(language.video_comment_popup_msg);
            }
            if (typeof(language.video_reCast_popup_msg) !== 'undefined') {
                this.setVideoReCastPopupMsg(language.video_reCast_popup_msg);
            }
            if (typeof(language.video_follow_popup_msg) !== 'undefined') {
                this.setVideoFollowPopupMsg(language.video_follow_popup_msg);
            }
            if (typeof(language.video_unFollow_popup_msg) !== 'undefined') {
                this.setVideoUnFollowPopupMsg(language.video_unFollow_popup_msg);
            }
            if (typeof(language.video_bookmark_popup_msg) !== 'undefined') {
                this.setVideoBookmarkPopupMsg(language.video_bookmark_popup_msg);
            }
            if (typeof(language.video_remove_bookmark_msg) !== 'undefined') {
                this.setVideoRemoveBookmarkMsg(language.video_remove_bookmark_msg);
            }
            if (typeof(language.tc_inside_tc_top_left_return_text) !== 'undefined') {
                this.setTcInsideTcTopLeftReturnText(language.tc_inside_tc_top_left_return_text);
            }
            if (typeof(language.tc_end_screen_share_this_touchcast) !== 'undefined') {
                this.setTcEndScreenShareThisTouchcast(language.tc_end_screen_share_this_touchcast);
            }
            if (typeof(language.tc_end_screen_download_touchcast) !== 'undefined') {
                this.setTcEndScreenDownloadTouchcast(language.tc_end_screen_download_touchcast);
            }
            if (typeof(language.tc_end_screen_replay_touchcast) !== 'undefined') {
                this.setTcEndScreenReplayTouchcast(language.tc_end_screen_replay_touchcast);
            }
            if (typeof(language.setting_tooltip) !== 'undefined') {
                this.setSettingsTooltip(language.setting_tooltip);
            }
            if (typeof(language.setting_subtitle_label) !== 'undefined') {
                this.setSettingsSubtitleLabel(language.setting_subtitle_label);
            }
            if (typeof(language.setting_subtitle_list_heading) !== 'undefined') {
                this.setSettingsSubtitleListHeading(language.setting_subtitle_list_heading);
            }
            if (typeof(language.subtitle_tooltip) !== 'undefined') {
                this.setSubtitleTooltip(language.subtitle_tooltip);
            }
            if (typeof(language.en_label) !== 'undefined') {
                this.setSubtitleLabel(language.en_label, 'en');
            }
            if (typeof(language.es_label) !== 'undefined') {
                this.setSubtitleLabel(language.es_label, 'es');
            }
            if (typeof(language.fr_label) !== 'undefined') {
                this.setSubtitleLabel(language.fr_label, 'fr');
            }
            if (typeof(language.ru_label) !== 'undefined') {
                this.setSubtitleLabel(language.ru_label, 'ru');
            }
            if (typeof(language.zh_label) !== 'undefined') {
                this.setSubtitleLabel(language.zh_label, 'zh');
            }
            if (typeof(language.pt_label) !== 'undefined') {
                this.setSubtitleLabel(language.pt_label, 'pt');
            }
            if (typeof(language.it_label) !== 'undefined') {
                this.setSubtitleLabel(language.it_label, 'it');
            }
            if (typeof(language.ja_label) !== 'undefined') {
                this.setSubtitleLabel(language.ja_label, 'ja');
            }
            if (typeof(language.hu_label) !== 'undefined') {
                this.setSubtitleLabel(language.hu_label, 'hu');
            }
            if (typeof(language.ru_label) !== 'undefined') {
                this.setSubtitleLabel(language.ru_label, 'ru');
            }
            if (typeof(language.br_label) !== 'undefined') {
                this.setSubtitleLabel(language.br_label, 'br');
            }
        }
    }
});
